import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: '{symbol} Reserve Overview',
  deposit: 'Deposit',
  borrow: 'Borrow',
});
